import type { Urun } from "./kancalar.js";

/** Barkod tam eşleşir; baştaki sıfırlar ve harf büyüklüğü korunur. */
export function urunleriSuz<T extends Pick<Urun, "ad" | "barkodlar">>(
  urunler: T[],
  arama: string,
): T[] {
  const sorgu = arama.trim();
  if (!sorgu) return urunler;
  const barkodlu = urunler.filter((u) => u.barkodlar.includes(sorgu));
  if (barkodlu.length) return barkodlu;
  const ad = sorgu.toLocaleLowerCase("tr");
  return urunler.filter((u) => u.ad.toLocaleLowerCase("tr").includes(ad));
}
